import { localize } from 'shared/components/other';
import { CampaignStatus } from 'types/campaign';

export function localizeCampaignStatus(status: CampaignStatus): string {
  const statusId = status.toLowerCase() as Lowercase<CampaignStatus>;
  const id = `campaigns.statuses.${statusId}` as `campaigns.statuses.${typeof statusId}`;
  return localize(id);
}
